import React from 'react';
import PropTypes from 'prop-types';
import { RaisedButton, TextField, Checkbox } from 'material-ui';
import { LinearProgress } from 'material-ui';
import { Toggle } from 'material-ui';
import ViewIcon from 'material-ui/svg-icons/image/view-comfy';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import { connect } from 'react-redux';
import fileDownload from 'js-file-download';
import get from 'lodash.get';
import { URL_FILE_DOWNLOAD, URL_PROJECT_EXPORT } from '../constants.js';
import fetcher from '../helpers/fetcher';
import { projectExport as projectExportAction } from '../actions/customProjectActions';
import DateTimeDisplay from './DateTimeDisplay.js';
import { getDateTimeForFilename } from '../helpers/date.js';

class ProjectExport extends React.Component {
  constructor(props) {
    super(props);
    const headers = get(props.record, 'meta.projectData.headers') || null;
    this.state = {
      showPreviousExports: false,
      includeCalls: true,
      includeAllHeaders: headers ? false : true,
      headers: headers
    };
  }

  _onClick = () => {
    const data = {
      projectId: this.props.record.id,
      contactUpdatedAtAfter: this.props.updatedAtAfter,
      contactUpdatedAtBefore: this.props.updatedAtBefore,
      includeCalls: this.state.includeCalls,
      includeAllHeaders: this.state.includeAllHeaders,
      ...(this.state.headers
        ? {
            headers: this.state.headers
          }
        : {})
    };
    if (this.props.multiple) {
      return fetcher
        .post(URL_PROJECT_EXPORT, data, { responseType: 'blob' })
        .then(response => {
          fileDownload(
            response.data,
            'export_projects_' +
              this.props.record.id.join('_') +
              '_' +
              getDateTimeForFilename() +
              '.xlsx'
          );
        });
    }
    this.props.projectExport(this.props.record.id, data);
  };

  _onDownloadClick = filename => {
    fetcher
      .get(`${URL_FILE_DOWNLOAD}/${filename}`, { responseType: 'blob' })
      .then(response => {
        fileDownload(response.data, filename);
      });
  };

  _onIncludeCallsCheck = (e, value) => {
    this.setState({ includeCalls: value });
  };

  _onIncludeAllHeaders = (e, value) => {
    this.setState({ includeAllHeaders: value });
  };

  _onHeadersChange = (e, value) => {
    this.setState({ headers: value || null });
  };

  _getCsvFilename = filename => {
    return filename.replace(/\.xlsx?$/i, '.csv');
  };

  _togglePreviousExports = () => {
    this.setState({ showPreviousExports: !this.state.showPreviousExports });
  };

  render() {
    const previousExports = (this.props.record.exports || [])
      .map(
        exportItem =>
          (
            <div key={`${exportItem.filename}${exportItem.at}`}>
              <br />
              <p>
                {exportItem.filename} {exportItem.at ? `generated at ` : ''}
                <DateTimeDisplay value={exportItem.at} />
              </p>
              <RaisedButton
                key={`file_${exportItem.filename}`}
                primary
                label={`Download EXCEL`}
                onClick={() => this._onDownloadClick(exportItem.filename)}
              />
              <RaisedButton
                key={`file_${exportItem.filename}_csv`}
                primary
                label={`Download CSV`}
                onClick={() =>
                  this._onDownloadClick(
                    this._getCsvFilename(exportItem.filename)
                  )
                }
              />
            </div>
          ) || []
      )
      .reverse();
    const latestExport = previousExports.length ? previousExports[0] : null;

    return (
      <div>
        <h3>Latest export</h3>
        {latestExport}
        <br />
        <br />
        {this.props.loading !== 0 && <LinearProgress />}
        <Checkbox
          label="Include Calls"
          checked={this.state.includeCalls}
          onCheck={this._onIncludeCallsCheck}
        />
        <Checkbox
          label="Include All Headers (ignores what's in the box below)"
          checked={this.state.includeAllHeaders}
          onCheck={this._onIncludeAllHeaders}
        />
        <TextField
          hintText="Headers"
          value={this.state.headers || ''}
          fullWidth={true}
          multiLine={true}
          onChange={this._onHeadersChange}
        />
        <RaisedButton
          disabled={this.loading}
          primary
          label="Export"
          onClick={this._onClick}
        />
        <br />
        <br />
        <Toggle
          label="Show previous exports"
          onToggle={this._togglePreviousExports}
          toggled={this.state.showPreviousExports}
          icon={<ViewIcon />}
        />
        {this.state.showPreviousExports && <h4>Previous Exports</h4>}
        {this.state.showPreviousExports && <div>{previousExports}</div>}
      </div>
    );
  }
}
ProjectExport.propTypes = {
  record: PropTypes.shape({
    id: PropTypes.number,
    exports: PropTypes.arrayOf(
      PropTypes.shape({
        filename: PropTypes.string
      })
    )
  }),
  updatedAtAfter: PropTypes.object,
  updatedAtBefore: PropTypes.object,
  projectExport: PropTypes.func,
  loading: PropTypes.number,
  multiple: PropTypes.bool
};

export default connect(
  state => ({
    loading: state.admin.loading
  }),
  {
    showNotification: showNotificationAction,
    projectExport: projectExportAction
  }
)(ProjectExport);



// WEBPACK FOOTER //
// ./src/components/ProjectExport.js